import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { useMsal } from "@azure/msal-react";
import ProfileContent from "../components/ProfileContent";

const Profile: React.FC = () => {
  const { accounts } = useMsal();
  const activeAccount = accounts[0];

  return (
    <Container>
      <Row className="justify-content-center">
        <Col md={10}>
          <div className="profile-container">
            <div className="text-center mb-4">
              <h2 className="display-5">
                <i className="fas fa-user-circle me-3"></i>
                Perfil de Usuario
              </h2>
              <p className="lead text-muted">
                Información obtenida de Microsoft Graph API
              </p>
            </div>

            <Row>
              <Col md={8}>
                <ProfileContent />
              </Col>
              <Col md={4}>
                <Card className="mb-4">
                  <Card.Header>
                    <Card.Title className="mb-0">
                      <i className="fas fa-info-circle me-2"></i>
                      Información de la Sesión
                    </Card.Title>
                  </Card.Header>
                  <Card.Body>
                    <p>
                      <strong>Cuenta activa:</strong>
                    </p>
                    <p className="text-muted small">
                      {activeAccount?.username ?? "N/A"}
                    </p>
                    <p>
                      <strong>Tipo de cuenta:</strong>
                    </p>
                    <p className="text-muted small">
                      {activeAccount?.homeAccountId?.includes(
                        "9188040d-6c67-4c5b-b112-36a304b66dad"
                      )
                        ? "Cuenta Personal (MSA)"
                        : "Cuenta Organizacional (Azure AD)"}
                    </p>
                    <p>
                      <strong>Entorno:</strong>
                    </p>
                    <p className="text-muted small">
                      {activeAccount?.environment ?? "N/A"}
                    </p>
                  </Card.Body>
                </Card>

                <Card>
                  <Card.Header>
                    <Card.Title className="mb-0">
                      <i className="fas fa-shield-alt me-2"></i>
                      Permisos Solicitados
                    </Card.Title>
                  </Card.Header>
                  <Card.Body>
                    <ul className="list-unstyled mb-0">
                      <li>✅ User.Read</li>
                      <li>✅ profile</li>
                      <li>✅ openid</li>
                      <li>✅ email</li>
                    </ul>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Profile;
